module.exports = __webpack_public_path__ + "img/user-regular.e5b1f6ed.svg";